import { render } from "./POImainContent.vue?vue&type=template&id=99c9e3c2"
import script from "./POImainContent.vue?vue&type=script&lang=js"
export * from "./POImainContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__